import { ExtensionLink } from "components/core/ExtensionLink";
import { AppPage } from "models/AppPage";
import { getNavItemClassName } from "utils/navigationStyles";

import { NavDropdown } from "./NavDropdown";

interface NavItemProps {
    page: AppPage;
    index: number;
    isPageActive: boolean;
    isDropdownActive: boolean;
    displayLabel: string;
    currentTag?: string;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
}

/**
 * Individual navigation item component
 * Handles navigation button and its associated dropdown menu
 */
export const NavItem = ({
    page,
    index,
    isPageActive,
    isDropdownActive,
    displayLabel,
    currentTag,
    onMouseEnter,
    onMouseLeave
}: NavItemProps) => {
    const hasChildren = page.children && page.children.length > 0;
    const isContentCuration =
        page.label === "콘텐츠 큐레이션" || page.label === "카테고리";

    // When on tag route and clicking 카테고리, scroll to top instead of navigating
    const handleClick = (e: React.MouseEvent) => {
        if (isContentCuration && currentTag) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <div
            key={`${page.label}-${index}`}
            className="group relative"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="relative flex w-full items-center gap-2">
                <ExtensionLink
                    href={page.href}
                    className={getNavItemClassName(
                        isPageActive,
                        isDropdownActive
                    )}
                    onClick={handleClick}
                >
                    {isDropdownActive ? "카테고리" : displayLabel}
                </ExtensionLink>
            </div>

            {/* Dropdown */}
            {hasChildren && isDropdownActive && (
                <NavDropdown page={page} currentTag={currentTag} />
            )}
        </div>
    );
};
